import { project2BaseUrl } from './remoteClient';

export async function sectorsRequest(token) {
    return await project2BaseUrl.get("/administration/getSectors", {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}